import React, { useEffect, useState } from "react";

import { DateTimeFormatter, LocalDateTime } from "@js-joda/core";
import { IDateTimeProps } from "components/dashboard/product-template-table/utils/interfaces";
import { formatDataPatternToCalendar } from "components/dashboard/product-template-table/utils/utils";
import { Calendar } from "primereact/calendar";
import { FormEvent } from "primereact/ts-helpers";
import { DATE_PATTERN_MINUTES } from "utils/constants";
import { addLeadingZeros } from "utils/utils";

export default function DateTime(props: IDateTimeProps) {
  const [date, setDate] = useState<Date | undefined>(
    props.value ? convertStringToDate(props.value) : undefined
  );
  const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    if (onCalendarFocus === false && date) {
      props.changeHandler(convertDateToString(date));
    }
  }, [onCalendarFocus]);

  function convertStringToDate(value: string) {
    if (value) {
      return new Date(Date.parse(value));
    }
    return undefined;
  }
  const hasHours = () => {
    let has = true;
    if (props.format) {
      has = props.format.split(" ")[1] !== undefined;
    }
    return has;
  };

  const convertDateToString = (d: Date): string => {
    const year = d.getFullYear();
    const month = addLeadingZeros(d.getMonth() + 1, 2);
    const day = addLeadingZeros(d.getDate(), 2);
    const hours = addLeadingZeros(d.getHours(), 2);
    const minutes = addLeadingZeros(d.getMinutes(), 2);
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const dateChangeHandler = (e: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
    if (e.value) {
      setDate(e.value as Date);
      props.changeHandler(convertDateToString(e.value as Date));
    }
  };

  const displayValue = () => {
    if (!props.value) return "N/A";

    try {
      const formatPattern = props.format ?? DATE_PATTERN_MINUTES;

      const formatter = DateTimeFormatter.ofPattern(DATE_PATTERN_MINUTES);
      const parsedDate = LocalDateTime.parse(props.value, formatter);

      const outputFormatter = DateTimeFormatter.ofPattern(formatPattern);
      return parsedDate.format(outputFormatter);
    } catch (error) {
      console.error("Error formatting date:", error);
      return props.value;
    }
  };

  const dateFormat = formatDataPatternToCalendar(props.format ?? DATE_PATTERN_MINUTES)?.split(
    " "
  )[0];

  if (props.isInEditMode) {
    return (
      <Calendar
        showTime={hasHours()}
        hourFormat="24"
        className="w-full"
        value={date}
        onChange={dateChangeHandler}
        dateFormat={dateFormat}
        stepMinute={5}
        onFocus={() => setOnCalendarFocus(true)}
        onHide={() => setOnCalendarFocus(false)}
        onInput={e => {
          const val = e.target as HTMLInputElement;
          if (!val.value) {
            setDate(undefined);
            props.changeHandler(undefined);
          }
        }}
      />
    );
    // TODO add formatter converter
  }
  return (
    <div
      className="p-inputtext"
      style={{
        border: "none",
        backgroundColor: "transparent",
        color: "inherit",
        whiteSpace: "pre-wrap",
      }}
    >
      {props.value ? displayValue().replaceAll("-", "-\u2060") : "N/A"}
    </div>
  );
}
